import { useCallback, useMemo } from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useSubmitPromoCodeMutation } from './GraphQL/PromoCode.generated';
import { useSubmitPromoOrGiftCardCodeMutation } from './GraphQL/SubmitPromoCodeOrGiftCard/SubmitPromoCodeOrGiftCard.generated';

export const useFeatureFlaggedSubmitPromoOrGiftCardCode = () => {
  const isLoyaltyServicePromoCodesEnabled = useFeatureFlag(
    'CELS-507-short-loyalty-svc-promo-codes-enabled',
  );

  const [submitPromoOrGiftCardCodeResponse, submitPromoOrGiftCardCodeMutation] =
    useSubmitPromoOrGiftCardCodeMutation();
  const [submitGiftCardResponse, submitGiftCardMutation] =
    useSubmitPromoCodeMutation();

  const response = isLoyaltyServicePromoCodesEnabled
    ? submitPromoOrGiftCardCodeResponse
    : submitGiftCardResponse;

  const submitPromoOrGiftCardCode = useCallback(
    async (code: string) => {
      if (isLoyaltyServicePromoCodesEnabled) {
        const { data, error } = await submitPromoOrGiftCardCodeMutation({
          input: { code },
        });

        const typename = data?.submitPromoOrGiftCardCode?.__typename;
        const isSubmitSuccess =
          typename === 'SubmitPromoCodeSuccessV2' ||
          typename === 'SubmitGiftCardCodeSuccess';

        return { isSubmitSuccess, data, typename, error };
      }

      const { data, error } = await submitGiftCardMutation({
        input: { code },
      });

      const typename = data?.submitPromoCode?.__typename;
      const isSubmitSuccess = typename === 'SubmitPromoCodeSuccess';

      return { isSubmitSuccess, data, typename, error };
    },
    [
      isLoyaltyServicePromoCodesEnabled,
      submitGiftCardMutation,
      submitPromoOrGiftCardCodeMutation,
    ],
  );

  return useMemo(
    () => ({ response, submitPromoOrGiftCardCode }),
    [response, submitPromoOrGiftCardCode],
  );
};
